// extracted by mini-css-extract-plugin
export default {"rules":"cXqvGCC9","nowrap":"RatV9eym"};